export const skillList = {
       'python': '90',
       'c-sharp': '70',
       'angular': '70',
       'react': '90',
       'sql': '100',
       'mongo-db': '90',
       'swift': '20',
       'micro-services': '50',
       'rabbit-mq': '50',
       'react-native': '30',
       'html5': '100',
       'css3': '100',
       'bootstrap': '90'

    }